
import Vue, { PropType } from "vue";
import { WorkerOverview } from "@/@modules/fseg/services/interfaces/worker/WorkerOverview";

export default Vue.extend({
  props: {
    hasData: {
      type: Boolean,
      required: true,
    },
    workerOverview: {
      type: Object as PropType<WorkerOverview>,
      required: true,
    },
  },
});
